import React        from 'react';
import { Link }     from 'react-router-dom';
import PropTypes 	from 'prop-types';

import Translations from '../../../utils/Translations';

const Freetext = (props) => {

    const { actorName, isCouple, isOverview , freeText, freeTextBody, freeTextHeadline, routeAboutMe  } = props;

    const titleKey = `actor_profile.overview_freetext_title${isCouple ? ".couple" : ".solo"}`;
    const title = isOverview ? Translations.get(titleKey) : freeTextHeadline;

    let text = isOverview ? freeText : freeTextBody;
    if (!text) {
        const textKey = `actor_profile.overview_freetext_dummy${isCouple}`;
        text = `${Translations.get(textKey)}<br/>${actorName}`;
    }

    return (
        <section className={isOverview ? "overview-infobox-container" : "container-block -margin-bottom-lg"}>
            <div className={isOverview ? "-fix-padding-md-down" : "col-xs-12 col-lg-8 col-lg-offset-2"}>
                <div className={isOverview ? "overview_freetext" : "context-box--actor-profile h-text-align-center"}>
                    {freeTextHeadline && <p
                        className               = {isOverview ? "context-box__title" : "actor-profile-about__show-text h-text-highlight"}
                        dangerouslySetInnerHTML = {{ __html: title }}
                    />}
                    <div className='overview_freetext-text'>
                        <p
                            className               = {isOverview ? "overview_freetext--body" : 'actor-profile-about__free-text'}
                            dangerouslySetInnerHTML = {{ __html: text }}
                        />
                        {isOverview && (
                            <Link
                                to={routeAboutMe || '#'}
                                className='js-pjax-link link -color-highlight'
                            >
                                {Translations.get('actor_profile.overview_freetext_learn-more')}...
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

Freetext.propTypes = {
    actorName:        PropTypes.string,
    isCouple:         PropTypes.bool,
    isOverview:       PropTypes.bool,
    freeText:         PropTypes.string,
    freeTextBody:     PropTypes.string,
    freeTextHeadline: PropTypes.string,
    routeAboutMe:     PropTypes.string,
};

export default Freetext;
